import { render, staticRenderFns } from "./WordpressUsers.vue?vue&type=template&id=500a582c"
import script from "./WordpressUsers.vue?vue&type=script&lang=js"
export * from "./WordpressUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports